<div id="orders" class="page-layout simple right-sidebar" fxLayout="row">

    <div class="center" fusePerfectScrollbar>

        <div style="padding: 20px;" class="header primary" fxLayout="column" fxLayoutAlign="center center"
            fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">
            <span class="mat-display-1 my-0 my-sm-24 welcome-message"
                [@animate]="{value:'*',params:{x:'50px'}}">{{'ROUTE_OPTIMIZATION_REPORT' | translate}}
            </span>
        </div>

        <div class="center p-20">
            <!-- <div class="my-20" fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap.lt-md="50px" fxLayoutGap="0px"
                fxLayoutAlign="space-around center">
                <mat-card fxFlex="45" fxFlex.lt-md="80" class="p-20 w-80-p">
                    <mat-card-title>{{'CONTAINER_OCCUPANCY_RATE' | translate}}</mat-card-title>
                    <div class="p-20">
                        <div>
                            <canvas style="width: 100%;" baseChart [data]="chartData" [colors]="colors"
                                [labels]="chartLabel" chartType="pie" [options]="chartOptions">
                            </canvas>
                        </div>
                    </div>
                </mat-card>
                <mat-card fxFlex="45" fxFlex.lt-md="80" class="p-20 w-80-p">
                    <mat-card-title>{{'CONTAINER_OCCUPANCY_RATE_OF_REGIONS' | translate}}</mat-card-title>
                    <div class="p-20">
                        <div>
                            <canvas style="width: 100%;" baseChart [datasets]="barChartData" [labels]="barLabel"
                                chartType="bar" [options]="chartBarOptions"></canvas>
                        </div>
                    </div>
                </mat-card>

            </div> -->

            <div class="content-card p-20" fxLayout="column" fxLayoutGap="20px">

                <div fxFlex="100">
                    <mat-card class="p-20" fxLayout="row wrap" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                        <div fxFlex="30" fxFlex.lt-lg="calc(40% - 20px)" fxFlex.lt-md="100" fxLayout="row" fxLayoutAlign="start center">
                            <div class="p-8">
                                <button mat-mini-fab (click)="setStartLocation()">
                                    <mat-icon>map</mat-icon>
                                </button>
                            </div>
                            <div>
                                <span class="start-location-title" style="display: block;">Başlangıç Konumu</span>
                                <span class="start-location-value">{{myLocation.lat + " / " + myLocation.lng}}</span>
                            </div>
                        </div>
            
                        <div fxFlex="20" fxFlex.lt-lg="calc(25% - 20px)" fxFlex.lt-md="100">
                            <div class="date-input">
                                <mat-form-field class="w-100-p" appearance="outline" floatLabel="always">
                                    <mat-label>{{'START_DATE'|translate}}</mat-label>
                                    <input matInput [matDatepicker]="startRatePicker" name="startRatePicker"
                                        placeholder="{{'START_DATE'|translate}}" [max]="endDate" [(ngModel)]="startDate" required>
                                    <mat-datepicker-toggle matSuffix [for]="startRatePicker"></mat-datepicker-toggle>
                                    <mat-datepicker #startRatePicker>
                                        <ng-template>
                                            <span>OK</span>
                                        </ng-template>
                                    </mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="date-input">
                                <mat-form-field class="w-100-p" appearance="outline" floatLabel="always">
                                    <mat-label>{{'END_DATE'|translate}}</mat-label>
                                    <input matInput [matDatepicker]="endRatepicker" name="endpicker"
                                        placeholder="{{'END_DATE'|translate}}" [min]="startDate" [(ngModel)]="endDate" required>
                                    <mat-datepicker-toggle matSuffix [for]="endRatepicker"></mat-datepicker-toggle>
                                    <mat-datepicker #endRatepicker>
                                        <ng-template>
                                            <span>OK</span>
                                        </ng-template>
                                    </mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
    
                        <div fxFlex="20" fxFlex.lt-lg="calc(25% - 20px)" fxFlex.lt-md="100" fxLayout="column" fxLayoutAlign="start center" class="select-zone">
                            <mat-form-field class="w-100-p" appearance="outline">
                                <mat-label>{{'REGION'|translate}}</mat-label>
                                <mat-select [(ngModel)]="selectPoligon">
                                    <mat-option *ngFor="let polygon of polygonList"
                                        (click)="selectPoligonClick()" [value]="polygon">
                                        {{polygon.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <div class="p-12" fxFlex fxLayoutAlign="center center">
                                <button mat-raised-button (click)="saveFilter()">Filtrele</button>
                            </div>
                        </div>
                        
                    </mat-card>
                </div>

                <div fxFlex="100">
                    <mat-card style="padding: 0 !important;">
                        <div class="px-20 pt-20 table-select-style" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    
                            
                            <mat-card-title fxFlex="70">{{'ROUTE_OPTIMIZATION_REPORT' | translate}}</mat-card-title>
    
                        
    
                            <button mat-mini-fab (click)="onReportClick()">
                                <mat-icon>cloud_download</mat-icon>
                            </button>                   
                        </div>
                        <div class="p-20 pt-0">
                            <mat-table class="orders-table" style="border-radius: 10px 10px 0px 0px;" #table
                                [dataSource]="dataSource" matSort [@animateStagger]="{value:'50'}" fusePerfectScrollbar>
    
                                <ng-container matColumnDef="poligonName">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'POLIGON_NAME' | translate}}
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let element">
                                        {{element.poligonName?element.poligonName:"---"}}
                                    </mat-cell>
                                </ng-container>
    
                                <ng-container matColumnDef="optimizeKm">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'OPTIMIZE_ROUTE' | translate}}
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let element" (click)="genericMapOptimizeRouting(element)">
                                        {{element.optimizeKm?(element.optimizeKm| number : '1.2-2') :"---"}} m
                                    </mat-cell>
                                </ng-container>
    
                                <ng-container matColumnDef="optimizeCount">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'OPTIMIZE_COUNT'|translate}}
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let element">
                                        {{element.optimizeCount?element.optimizeCount:'---'}}
                                    </mat-cell>
                                </ng-container>
    
                                <ng-container matColumnDef="baseKm">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'BASE_ROUTE' | translate}}
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let element" (click)="genericMapBaseRouting(element)">
                                        {{element.baseKm?(element.baseKm| number : '1.2-2') :"---"}} m
                                    </mat-cell>
                                </ng-container>
    
                                <ng-container matColumnDef="baseCount">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'BASE_COUNT'|translate}}
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let element">
                                        {{element.baseCount?element.baseCount:'---'}}
                                    </mat-cell>
                                </ng-container>
    
                                <ng-container matColumnDef="rate">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'PROFIT_RATE'|translate}}
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let element">
                                        {{100-(((element.optimizeKm/element.baseKm)*100))|number : '1.2-2'}} %
                                    </mat-cell>
                                </ng-container>
    
                                <ng-container matColumnDef="date">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'DATE'|translate}}
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let element">
                                        {{element.date?element.date:"---"}}
                                    </mat-cell>
                                </ng-container>
    
    
    
                                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                                <mat-row *matRowDef="let element; columns: displayedColumns;" class="order" matRipple>
                                </mat-row>
                            </mat-table>
    
                            <mat-paginator #paginator [length]="paginator.length" [pageSize]="10"
                                [pageSizeOptions]="[10, 50, 100]">
                            </mat-paginator>
                        </div>
                        <mat-progress-bar [fxShow]="tableLoading" style="border-radius: 10px;" mode="indeterminate">
                        </mat-progress-bar>
                    </mat-card>
                </div>

            </div>
        </div>

    </div>
</div>